import { createElement, ReactElement } from 'react'

export enum WidgetTypes {
    CHART = 'CHART',
    OI_CHART = 'OI_CHART',
    MULTI_STRIKE_CHART = 'MULTI_STRIKE_CHART',
    OPTION_CHAIN = 'OPTION_CHAIN',
    FUTURE_CHART = 'FUTURE_CHART',
    ATM_OPTION_CHART = 'ATM_OPTION_CHART',
    OPTION_CHART = "OPTION_CHART"
}

export const WidgetTypesNames: Record<WidgetTypes, string> = {
    [WidgetTypes.CHART]: 'Candle chart',
    [WidgetTypes.OI_CHART]: 'OI chart',
    [WidgetTypes.MULTI_STRIKE_CHART]: 'Multi strike chart',
    [WidgetTypes.OPTION_CHAIN]: 'Option chain',
    [WidgetTypes.FUTURE_CHART]: '',
    [WidgetTypes.ATM_OPTION_CHART]: '',
    [WidgetTypes.OPTION_CHART]: '',
}

export const WidgetTypeMap: Record<WidgetTypes, ReactElement> = {
    [WidgetTypes.CHART]: createElement('div'),
    [WidgetTypes.OI_CHART]: createElement('div'),
    [WidgetTypes.MULTI_STRIKE_CHART]: createElement('div'),
    [WidgetTypes.OPTION_CHAIN]: createElement('div'),
    [WidgetTypes.FUTURE_CHART]:createElement('div'),
    [WidgetTypes.ATM_OPTION_CHART]:createElement('div'),
    [WidgetTypes.OPTION_CHART]: createElement('div'),
}

export enum PredefinedDashboard {
    LAYOUT_1,
    LAYOUT_H2,
    LAYOUT_V2,
    LAYOUT_V3,
    LAYOUT_H3,
    LAYOUT_H2_2V2,
    LAYOUT_V2_1H2,
    LAYOUT_V2_2H2,
    LAYOUT_H2_1V2,
    LAYOUT_V4,
    LAYOUT_H4,
    LAYOUT_V2_2H3,
    LAYOUT_V2_1H2_2V2,
    LAYOUT_H2_2V3,
    LAYOUT_H2_1V3,
    LAYOUT_H2_1V2_2V2,
    LAYOUT_H2_1H2_2V2
}